var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22C16.3919 22 20 18.7371 20 14.5491C20 12.1531 19.4668 10.5 17.9632 7.71395C16.8001 9.5 15.5734 10.2311 15.2001 10.5C14.1334 7 13.0667 5 10.4 2C8 8.36364 4 9.57396 4 14.5491C4 18.7371 7.60818 22 12.0001 22Z",
    stroke: "#EE4444",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C14.196 22 16 20.3686 16 18.2745C16 17.0765 15.7334 16.25 14.9816 14.857C14.4 15.75 13.7867 16.1156 13.6 16.25C13.0667 14.5 12.5334 13.5 11.2 12C10 15.1818 8 15.787 8 18.2745C8 20.3686 9.80409 22 12 22Z",
    stroke: "#EE4444",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurn);
export default __webpack_public_path__ + "static/media/burn.4635b830e429562b0520cf0b99ec1eab.svg";
export { ForwardRef as ReactComponent };